import axios from '@/lib/axios';
import {useQuery} from '@tanstack/react-query';

type Props = {
  token: string;
  pin_code: string;
}

const passwordReset = (props: Props): Promise<any> => {
  return axios.get(`/api/user_password_resets/${props.token}`, { params: props });
};

export const usePasswordReset = (props: Props) => {
  return useQuery({
    queryKey: ['user_password_resets', props.token, props.pin_code],
    queryFn: () => passwordReset(props),
    enabled: false,
  })
}